// @flow
import styled from 'styled-components';

export const Container = styled.div`height: 100vh;`;



// WEBPACK FOOTER //
// ./src/components/widgets/indicators/login/styles.js